// SPDX-FileCopyrightText: 2024 Sequent Tech <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import polyglotI18nProvider from "ra-i18n-polyglot";
import englishMessages from "ra-language-english";
var spanishMessages = __assign(__assign({}, englishMessages), { ra: __assign(__assign({}, englishMessages.ra), { action: __assign(__assign({}, englishMessages.ra.action), { add_filter: "Añadir filtro", select_columns: "Columnas", save: "Guardar", confirm: "Confirmar", create: "Crear", create_item: "Crear %{item}", delete: "Borrar", edit: "Editar", export: "Exportar", list: "Lista", refresh: "Refrescar" }) }) });
export var adminI18nProvider = polyglotI18nProvider(function (locale) {
    return locale === "es" ? spanishMessages : englishMessages;
}, "en" // Default locale
);
